import { c as _c } from "react/compiler-runtime";
import BnefLogo from '@/components/Atoms/BnefLogo/BnefLogo';
import type { IHeadMetaProps } from '@/components/Molecules/HeadMeta/HeadMeta';
import { Stack } from '@/components/Molecules/Stack/Stack';
import { getLoginRedirectUrl } from '@/utils/siteUtils';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useEffect } from 'react';
import styles from './TransparentRedirectView.module.css';

/**
 * A page view that contains only a link to login for the current page
 * Used on the core content types to enable social sharing enhancements to work
 */
export const RequireLogin: FC<{
  publicMetadata?: IHeadMetaProps;
}> = t0 => {
  const $ = _c(14);
  const {
    publicMetadata
  } = t0;
  const {
    asPath
  } = useRouter();
  let t1;
  if ($[0] !== asPath) {
    t1 = getLoginRedirectUrl(asPath);
    $[0] = asPath;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const loginUrl = t1;
  let t2;
  if ($[2] !== loginUrl) {
    t2 = () => {
      window.location.href = loginUrl;
    };
    $[2] = loginUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={styles.logoSpace} title="BloombergNEF"><BnefLogo /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== publicMetadata) {
    t5 = publicMetadata?.title && <h1>{publicMetadata.title}</h1>;
    $[6] = publicMetadata;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p>You must login to view this content.</p>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== loginUrl) {
    t7 = <a className="cds-button" href={loginUrl}>Login</a>;
    $[9] = loginUrl;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <div className={styles.container}><Stack>{t4}{t5}{t6}{t7}</Stack></div>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};